export default {
  'Enter a promo code! First limit people receive amount coins':
    '輸入促銷碼！第一批玩家會收到定額金幣',
};
